import {BaseAppModel} from "./AppModel";

export enum FirmwareStatus {
    TESTING = "TESTING",
    PUBLISHED = "PUBLISHED",
    UNUSUAL = "UNUSUAL",
}

export const firmwareStatusZh = {
    TESTING: "测试中",
    PUBLISHED: "已发布",
    UNUSUAL: "异常",
}

export default class Firmware extends BaseAppModel<Firmware> {
    productId!: number
    version!: string
    url!: string
    status!: FirmwareStatus
    enabled!: boolean
    allowedDelete!: boolean
    allowedPublish!: boolean
    allowedUnusual!: boolean
    description?: string
    remark?: string
}
